<div>
  <img *ngIf="loading" src="{{ spinnerSrc }}" alt="loading" [class]="imgClass" />
  <img [hidden]="loading" (load)="onLoad()" src="{{ imgSrc }}" alt="{{ imgAlt }}" [class]="imgClass" />
</div>
